import { Manufacturer } from 'core/types/manufacturer';

import { Action, SET_MANUFACTURERS } from './actions';

export default (
  state: Manufacturer[] = null as any,
  action: Action
): Manufacturer[] => {
  switch (action.type) {
    case SET_MANUFACTURERS:
      return action.payload;
    default:
      return state;
  }
};
